// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-title {
  display: flex;
  align-items: center;
  margin-top: 97px;
  margin-bottom: 24px;
  line-height: 1;
  font-size: 31px;
  font-weight: 700;
  position: relative;
}
.detail-title ion-icon {
  height: 22px;
  border-radius: 50%;
  padding: 8px;
  position: absolute;
  right: 0px;
  width: 22px;
  cursor: pointer;
  color: #ffffff;
  background: var(--ion-color-primary);
}
.detail-title .subtitle {
  padding-left: 51px;
  margin-bottom: 0px;
  position: relative;
}
.detail-title .back-icon {
  left: 0px;
}

.section-logo {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  min-height: 203px;
  margin-left: 3px;
  margin-right: 3px;
}
.section-logo .container-image {
  margin-top: 20px;
}
.section-logo .container-image div {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  padding: 5px;
  background-size: cover;
  margin: 0 auto;
}
.section-logo .default-image {
  padding: 5px;
  width: 149px;
  height: 149px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
  border: 4px solid var(--icons, #0C2340);
}
.section-logo .default-image img {
  width: 142px;
  height: 132px;
  border-radius: 50%;
  border: none;
}
.section-logo .business-name {
  color: #0C2340;
  text-align: center;
  font-size: 20px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 8px;
  margin-top: 12px;
}
.section-logo .company-name {
  color: #586677;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-top: 0px;
}

.col-center {
  padding-left: 14px !important;
  padding-top: 15px;
  display: flex;
  align-items: center;
}

.section-info {
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);
  margin-top: 24px;
  margin-left: 3px;
  margin-right: 3px;
  margin-bottom: 5px;
}
.section-info ion-grid {
  margin: 0px;
  padding: 0px;
}
.section-info ion-grid ion-row {
  border-bottom: 1px solid #D8D8D8;
  padding: 0px 16px 16px 0px;
}
.section-info ion-grid ion-row ion-col span {
  color: #43556A;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  width: 100%;
}
.section-info ion-grid ion-row ion-col .detail {
  font-weight: 700;
}
.section-info ion-grid ion-row ion-col:first-child {
  padding-left: 24px;
}
.section-info ion-grid .no-border {
  border-bottom: none;
}

.default-no-item {
  padding: 0px 20px;
}

.container-verified {
  padding: 0px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.container-verified .container-gbp-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container-verified .container-gbp-success img {
  margin-top: 0px;
}
.container-verified .container-gbp-success .check {
  margin-bottom: 27px;
}
.container-verified .container-gbp-success .google {
  width: 195.429px;
  height: 64px;
}
.container-verified .container-gbp-success .detail-text {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.connect-title {
  color: var(--text-Subttulos, #0D253A);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 8px;
}

.reply-text {
  color: var(--text-BODY, #2C4051);
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 0px;
}

.container-gbp-images {
  position: relative;
}
.container-gbp-images .bg {
  width: 288.089px;
  height: 259.015px;
  margin-top: 40px;
}
.container-gbp-images .google {
  margin-top: 0px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 95.167px;
  height: 95.167px;
  padding-top: 6px;
}
.container-gbp-images .stars {
  margin-top: 0px;
  position: absolute;
  top: 62%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 6px;
  width: 148.622px;
  height: 65.209px;
}

.container-gbp-actions {
  margin-bottom: 0px;
  margin-top: 8px;
}

.footer-modal ion-toolbar {
  --background: #f8f8f8;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/components/gmb-success/gmb-success.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;AACJ;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,SAAA;AADJ;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAIE;EASE,gBAAA;AAVJ;AAYI;EAME,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAfN;AAmBE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uCAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAjBN;AAqBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AApBJ;;AAwBA;EACE,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AArBF;AAuBE;EACE,WAAA;EACA,YAAA;AArBJ;AAuBI;EACE,gCAAA;EACA,0BAAA;AArBN;AAwBQ;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAtBV;AAyBQ;EACE,gBAAA;AAvBV;AA2BM;EACE,kBAAA;AAzBR;AA6BI;EACE,mBAAA;AA3BN;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA7BF;AA+BE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA7BJ;AA+BI;EACE,eAAA;AA7BN;AAgCI;EACE,mBAAA;AA9BN;AAiCI;EACE,gBAAA;EACA,YAAA;AA/BN;AAkCI;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhCN;;AAqCA;EACE,qCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,gCAAA;EACA,kBAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,kBAAA;AAlCF;AAoCE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AApCJ;;AAwCA;EACE,kBAAA;EACA,eAAA;AArCF;;AAyCE;EACE,qBAAA;AAtCJ","sourcesContent":[".detail-title {\n  display: flex;\n  align-items: center;\n  margin-top: 97px;\n  margin-bottom: 24px;\n  line-height: 1;\n  font-size: 31px;\n  font-weight: 700;\n  position: relative;\n\n  ion-icon {\n    height: 22px;\n    border-radius: 50%;\n    padding: 8px;\n    position: absolute;\n    right: 0px;\n    width: 22px;\n    cursor: pointer;\n    color: #ffffff;\n    background: var(--ion-color-primary);\n  }\n\n  .subtitle {\n    padding-left: 51px;\n    margin-bottom: 0px;\n    position: relative;\n  }\n\n  .back-icon {\n    left: 0px;\n  }\n}\n\n.section-logo {\n  border-radius: 8px;\n  background: #FFF;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  padding-top: 16px;\n  padding-bottom: 16px;\n  text-align: center;\n  min-height: 203px;\n  margin-left: 3px;\n  margin-right: 3px;\n\n  .container-image {\n    // padding: 5px;\n    // width: 149px;\n    // height: 149px;\n    // border-radius: 50%;\n    // box-sizing: border-box;\n    // margin: 0 auto;\n    // border: 4px solid var(--icons, #0C2340);\n    // position: relative;\n    margin-top: 20px;\n\n    div {\n      // width: 131px;\n      // height: 131px;\n      // border-radius: 50%;\n      // padding: 5px;\n      // background-size: cover;\n      width: 80px;\n      height: 80px;\n      border-radius: 50%;\n      padding: 5px;\n      background-size: cover;\n      margin: 0 auto;\n    }\n  }\n\n  .default-image {\n    padding: 5px;\n    width: 149px;\n    height: 149px;\n    border-radius: 50%;\n    box-sizing: border-box;\n    margin: 0 auto;\n    border: 4px solid var(--icons, #0C2340);\n\n    img {\n      width: 142px;\n      height: 132px;\n      border-radius: 50%;\n      border: none;\n    }\n  }\n\n  .business-name {\n    color: #0C2340;\n    text-align: center;\n    font-size: 20px;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    line-height: 28px;\n    margin-bottom: 8px;\n    margin-top: 12px;\n  }\n\n  .company-name {\n    color: #586677;\n    text-align: center;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 21px;\n    margin-top: 0px;\n  }\n}\n\n.col-center {\n  padding-left: 14px !important;\n  padding-top: 15px;\n  display: flex;\n  align-items: center;\n}\n\n.section-info {\n  border-radius: 8px;\n  background: #FFF;\n  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.15);\n  margin-top: 24px;\n  margin-left: 3px;\n  margin-right: 3px;\n  margin-bottom: 5px;\n\n  ion-grid {\n    margin: 0px;\n    padding: 0px;\n\n    ion-row {\n      border-bottom: 1px solid #D8D8D8;\n      padding: 0px 16px 16px 0px;\n\n      ion-col {\n        span {\n          color: #43556A;\n          font-size: 15px;\n          font-style: normal;\n          font-weight: 500;\n          line-height: 21px;\n          width: 100%;\n        }\n\n        .detail {\n          font-weight: 700;\n        }\n      }\n\n      ion-col:first-child {\n        padding-left: 24px;\n      }\n    }\n\n    .no-border {\n      border-bottom: none;\n    }\n  }\n}\n\n.default-no-item {\n  padding: 0px 20px;\n}\n\n.container-verified {\n  padding: 0px 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  .container-gbp-success {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    img{\n      margin-top: 0px;\n    }\n\n    .check{\n      margin-bottom: 27px;\n    }\n\n    .google{\n      width: 195.429px;\n      height: 64px;\n    }\n\n    .detail-text{\n      color: var(--text-Subttulos, #0D253A);\n      text-align: center;\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: normal;\n    }\n  }\n}\n\n.connect-title {\n  color: var(--text-Subttulos, #0D253A);\n  text-align: center;\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: 'Poppins';\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-bottom: 8px;\n}\n\n.reply-text {\n  color: var(--text-BODY, #2C4051);\n  text-align: center;\n  font-feature-settings: 'liga' off, 'clig' off;\n  font-family: 'Poppins';\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.container-gbp-images {\n  position: relative;\n\n  .bg {\n    width: 288.089px;\n    height: 259.015px;\n    margin-top: 40px;\n  }\n\n  .google {\n    margin-top: 0px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 95.167px;\n    height: 95.167px;\n    padding-top: 6px;\n  }\n\n  .stars {\n    margin-top: 0px;\n    position: absolute;\n    top: 62%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding-top: 6px;\n    width: 148.622px;\n    height: 65.209px;\n  }\n}\n\n.container-gbp-actions {\n  margin-bottom: 0px;\n  margin-top: 8px;\n}\n\n.footer-modal {\n  ion-toolbar {\n    --background: #f8f8f8;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
